var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminJobList',{attrs:{"hideOwnershipFilters":true,"lockedFilters":{ CustomerIdList: [_vm.$route.params.customerId] }}})}
var staticRenderFns = []

export { render, staticRenderFns }